import Events from '@pixelunion/events';
import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticFooter {
  constructor(section) {
    this.el = section.el;
    this.mailingListEl = this.el.querySelector('.mailing-list');
    this.upperFooterEl = this.el.querySelector('.upper-footer');
    this.events = new Events();

    const currencyDisclosureEl = section.el.querySelector('[data-disclosure-currency]');
    const localeDisclosureEl = section.el.querySelector('[data-disclosure-locale]');

    if (currencyDisclosureEl) {
      this.currencyDisclosure = new Disclosure(currencyDisclosureEl);
    }

    if (localeDisclosureEl) {
      this.localeDisclosure = new Disclosure(localeDisclosureEl);
    }

    this.events.register(window, 'resize', () => {
      if (!this.mailingListEl) return;

      if ((window.innerWidth <= 1080) && (window.innerWidth !== this.width)) {
        this.upperFooterEl.insertBefore(this.mailingListEl, this.upperFooterEl.firstChild);
      } else if (window.innerWidth !== this.width) {
        this.upperFooterEl.appendChild(this.mailingListEl);
      }
    });
  }

  onSectionUnload() {
    this.events.unregisterAll();

    if (this.currencyDisclosure) {
      this.currencyDisclosure.unload();
    }

    if (this.localeDisclosure) {
      this.localeDisclosure.unload();
    }
  }
}
